import * as yup from "yup";
import hospitalaria_off from "../assets/img/icon/icon_red_hospitalaria_off.svg";
import ambulatoria_off from "../assets/img/icon/icon_red_ambulatoria_off.svg";
import selectos_off from "../assets/img/icon/icon_paquetes_selectos_off.svg";
import farmacias_off from "../assets/img/icon/icon_red_farmacias_off.svg";
import todos_off from "../assets/img/icon/icon_todos_off.svg";

export const v_beneficio = yup.object().shape({
    cdAseguradora: yup.string().required("Seleccione una aseguradora"),
    cdRedCob: yup.string().required("Seleccione un nombre de red"),
    red: yup.string().required("Seleccione una red"),
    especialidad: yup.string().required("Seleccione una especialidad"),
    // nombre: yup.string().required('Ingrese un nombre'),
});

export const getDefaultBen = () => {
    return {
        cdBeneficio: null,
        cdPlan: "",
        red: "",
        cdAseguradora: "",
        especialidad: "",
        protocolo: "",
        paquete: "",
        nombreProveedor: "",
        nombre: "",
        puntoVenta: "",
        ciudad: "",
        direccion: "",
        telefono: "",
    };
};

export const ListRedes = [
    { id: "RED HOSPITALARIA", label: "RED HOSPITALARIA", letra: "H" },
    { id: "RED AMBULATORIA", label: "RED AMBULATORIA", letra: "A" },
    { id: "RED FARMACIA", label: "RED FARMACIA", letra: "F" },
    { id: "RED SELECTA", label: "RED SELECTA", letra: "S" },
    { id: "ALL REDES", label: "TODAS LAS REDES", letra: "ALL" },
];

export const findRed = id => {
    switch (id) {
        case "H":
            return "Red Hospitalaria";
        case "A":
            return "Red Ambulatoria";
        case "F":
            return "Red Farmacia";
        case "S":
            return "Red Selecta";
        case "ALL":
            return "Todas las Redes";
        default:
            return "";
    }
};

export const findImageRed = id => {
    switch (id) {
        case "H":
            return hospitalaria_off;
        case "A":
            return ambulatoria_off;
        case "F":
            return farmacias_off;
        case "S":
            return selectos_off;
        case "ALL":
            return todos_off;
        default:
            return "";
    }
};
